import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api-client';

/**
 * แผนก = เลือกจากที่มี (dropdown) หรือสร้างใหม่. กันสร้างซ้ำที่ฝั่ง server
 * (departments master, dedup ด้วย name_norm). controlled: value/onChange.
 * ค่าที่ส่งออกคือ "ชื่อแผนก" (string) — ว่างได้ (ไม่บังคับ).
 */
interface Dept {
  id: string | null;
  name: string;
}
const NEW = '__new__';

export function DepartmentSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  const { data } = useQuery({
    queryKey: ['hr', 'departments'],
    queryFn: () => apiFetch<{ departments: Dept[] }>('/hr/departments'),
    staleTime: 60_000,
  });
  const options = data?.departments ?? [];
  const inList = !value || options.some((d) => d.name === value);
  // เข้าโหมดสร้างใหม่เมื่อกดเลือก "เพิ่มแผนกใหม่" หรือค่าปัจจุบันไม่อยู่ในลิสต์
  const [creating, setCreating] = useState(false);
  const showInput = creating || !inList;

  if (showInput) {
    return (
      <div className="space-y-1">
        <input
          className="input"
          placeholder="ชื่อแผนกใหม่ (เว้นว่างได้)"
          value={value}
          autoFocus
          onChange={(e) => onChange(e.target.value)}
        />
        {options.length > 0 && (
          <button
            type="button"
            className="text-xs text-brand-600 hover:underline"
            onClick={() => {
              setCreating(false);
              onChange('');
            }}
          >
            ← เลือกจากแผนกที่มีอยู่
          </button>
        )}
      </div>
    );
  }

  return (
    <select
      className="input"
      value={value}
      onChange={(e) => {
        if (e.target.value === NEW) {
          setCreating(true);
          onChange('');
        } else {
          onChange(e.target.value);
        }
      }}
    >
      <option value="">— ไม่ระบุแผนก —</option>
      {options.map((d) => (
        <option key={d.id ?? d.name} value={d.name}>
          {d.name}
        </option>
      ))}
      <option value={NEW}>＋ เพิ่มแผนกใหม่…</option>
    </select>
  );
}
